class SeoDropdown extends HTMLElement {
  constructor() {
    super();
    this.accordionItems = this.querySelectorAll('.accordion-item');
    this.init()
  }

  init() {
    this.accordionItems.forEach(item => {
      item.addEventListener('click', function () {
        this.classList.toggle('active');
        this?.querySelector('.accordion-item-body').classList.toggle('hidden')
      })
    })
  }
}

customElements.define('lv-seo-dropdown', SeoDropdown);